export const EntityModalForm = {

    getForm(entity, type, id=null, additional={}) {
        let formHTML;
        $.ajax({
            method: "GET",
            url: `${this.sectionRootUrl}/form?${$.param({ entity, type, id, 'form-request': true, ...additional})}`,
            async: false,
            success: (response) => {
                if (response.redirect) window.location = response.redirect;
                else formHTML = response;
            }
        });
        return formHTML;
    },

    pasteForm(formHTML, formId='form-container') {
        const formContainer = $(`#${formId}`);
        formContainer.html(formHTML);
    },

    openModal(type, options={},isRead=true) {
        const id = options.id ?? this.id
        delete options.id
        let formHTML = this.getForm(this.entityClass, type, id, options ?? {});
        this.pasteForm(formHTML);

        const formId = `${type}-${this.entityClass}`;
        if(isRead)
            this.completeForm(formId, options);
        let ev = new CustomEvent('load_modal',{bubbles:true})
        ev.modalId = formId
        ev.entityId = id
        document.dispatchEvent(ev)
        $('.modal-backdrop').first().remove();
        $(`#${formId}-modal`).modal('show');
        $('.modal-window-actions').hide();

        $('input[disabled], select[disabled], textarea[disabled], .form-control[disabled]');
        this.delegatedListnersForButtons(type, this.entityClass);
    },

    delegatedListnersForButtons(type, entityClass) {
        $(`#${type}-${entityClass} button#${type}`).off();
        $(`#${type}-${entityClass} button#${type}`).on('click', () => {
            if (type == 'create') {
                this.create();
            }
            if (type == 'edit') {
                this.update();
            }
        });
    },

    hideModal(formId) {
        $(`form#${formId}`)[0].reset();
        $(`#${formId}-modal`).modal('hide');
    },
}

